// src/context/DataContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { getProducts, getNiches } from "../firebase/services";

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [niches, setNiches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  console.log('jhdebhhewh')

  const fetchData = async () => {
    setLoading(true);
    try {
      const [productsData, nichesData] = await Promise.all([
        getProducts({ active: true }),
        getNiches(),
      ]);
      setProducts(productsData);
      setNiches(nichesData);
    } catch (err) {
      console.error("Failed to load data:", err);
      setError(err.message);
      // Fallback to static data if Firebase not configured
      setProducts(STATIC_PRODUCTS);
      setNiches(STATIC_NICHES);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ products, niches, loading, error, refresh: fetchData }}>
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error("useData must be used within DataProvider");
  return ctx;
}

// ─── STATIC FALLBACK DATA (used if Firebase is not yet configured) ────────────

const STATIC_NICHES = [
  {
    id: "agriculture",
    name: "Agriculture & Organic",
    slug: "agriculture",
    tagline: "Crafted for a Greener Tomorrow",
    description: "Premium organic agricultural solutions to restore soil vitality and promote healthier growth—naturally.",
    icon: "🌱",
    color: "#2C5F2D",
    accentColor: "#97BC62",
    order: 1,
  },
  {
    id: "home-garden",
    name: "Home Gardening",
    slug: "home-garden",
    tagline: "Nurturing Nature Naturally",
    description: "Beautiful, thriving gardens start with the right nutrients. Our home gardening range is designed for every plant lover.",
    icon: "🏡",
    color: "#5C4033",
    accentColor: "#A1887F",
    order: 2,
  },
  {
    id: "landscaping",
    name: "Landscaping & Nurseries",
    slug: "landscaping",
    tagline: "Grow Better, Grow Organic",
    description: "Professional-grade organic solutions for landscapers, nurseries, and commercial growers.",
    icon: "🌿",
    color: "#1B5E20",
    accentColor: "#66BB6A",
    order: 3,
  },
];

const STATIC_PRODUCTS = [
  {
    id: "urvaraa-1",
    name: "Urvaraa Vermicompost",
    slug: "urvaraa-vermicompost",
    tagline: "Crafted for a Greener Tomorrow",
    description:
      "Urvaraa Vermicompost is a premium organic fertilizer produced through natural decomposition using earthworms. It enhances soil fertility, improves structure, and promotes strong, healthy plant growth.",
    category: "Organic Fertilizers",
    niches: ["agriculture", "home-garden", "landscaping"],
    benefits: [
      "Improves soil aeration",
      "Enhances water retention",
      "Boosts plant growth and yield",
      "Rich in essential nutrients",
      "Promotes root development",
      "100% organic and eco-friendly",
    ],
    usageSuitability: ["Agriculture", "Home gardening", "Nurseries", "Landscaping"],
    howToUse:
      "Mix with soil before planting or apply around plant roots. Water after application for best results.",
    variants: [
      { size: "2 Kg", price: null, sku: "URV-2KG" },
      { size: "5 Kg", price: null, sku: "URV-5KG" },
    ],
    badges: ["100% Organic", "Chemical-Free", "Enhanced Soil Booster"],
    imageUrl: "",
    enquiryEmail: "sales@sunaharco.com",
    featured: true,
    active: true,
    comingSoon: false,
    order: 1,
  },
];
